import type { ReactNode } from 'react';

import Input from '@/components/Input/Input';

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from '../CFormItem';

type Props = CFormItemProps & {
  value?: string;
  readComponent?: ReactNode;
  onChange?: (value?: string) => void;
  inputWidth?: number | string;
  inputClassName?: string;
};

/**
 * Card-based Form / TextItem
 */
export const CFormTextItem = buildCFormItem<Props>((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={props.readComponent ?? props.value}
      writeComponent={
        <Input
          value={props.value ?? ''}
          onChange={(e) => props.onChange?.(e.target.value || undefined)}
          width={props.inputWidth}
          className={props.inputClassName}
          disabled={props.readonly}
        />
      }
    />
  );
});
